import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Lock } from 'lucide-react';
import { motion } from 'framer-motion';
export function OfferBlock() {
  return <section id="offer" className="py-20 px-6 max-w-3xl mx-auto text-center mb-20" data-id="element-79">
      <FadeIn data-id="element-80">
        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-sage/20 relative overflow-hidden" data-id="element-81">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-sage via-terracotta to-sage" data-id="element-82"></div>

          <h2 className="font-serif text-3xl md:text-4xl text-charcoal mb-6 leading-tight" data-id="element-83">
            Stop the 11 PM panic.
          </h2>

          <p className="text-lg font-sans text-charcoal-light mb-8 max-w-xl mx-auto" data-id="element-84">
            Get the exact blueprint used to reset the gut and flatten the
            stomach in just 72 hours.
          </p>

          <div className="mb-8" data-id="element-85">
            <span className="block text-sm font-sans text-sage font-semibold uppercase tracking-wider mb-2" data-id="element-86">
              Direct-access digital download
            </span>
            <div className="flex items-center justify-center gap-3 flex-wrap" data-id="element-87">
              <span className="font-serif text-2xl text-charcoal-light/50 line-through" data-id="element-88">
                $19
              </span>
              <span className="font-serif text-5xl text-charcoal font-medium" data-id="element-89">
                $9.99 <span className="text-2xl text-charcoal-light" data-id="element-90">AUD</span>
              </span>
            </div>
            <span className="inline-block mt-3 px-4 py-1 bg-terracotta/15 text-terracotta font-sans text-sm font-semibold rounded-full" data-id="element-91">
              Save 47% — Limited Time
            </span>
          </div>

          <motion.a href="https://www.versastorex.com/cart/42109998366800:1" target="_blank" rel="noopener noreferrer" onClick={() => {
          if ((window as any).fbq) {
            ;
            (window as any).fbq('track', 'AddToCart', {
              content_name: 'The 72-Hour Bloat Protocol',
              content_type: 'product',
              value: 9.99,
              currency: 'AUD'
            });
          }
        }} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-block w-full md:w-auto px-10 py-5 bg-sage hover:bg-sage-dark text-white rounded-full font-sans font-semibold text-lg shadow-[0_0_20px_rgba(107,143,113,0.4)] transition-colors duration-300 no-underline" data-id="element-92">
            Get The 72-Hour Protocol Now
          </motion.a>

          <div className="mt-6 flex items-center justify-center gap-2 text-sm text-charcoal-light font-sans" data-id="element-93">
            <Lock className="w-4 h-4 text-sage" data-id="element-94" />
            <span data-id="element-95">Secure checkout. Instant PDF access.</span>
          </div>
        </div>
      </FadeIn>
    </section>;
}